<template>
    <el-dialog
            :visible.sync="dialogVisible"
            width="1224px"
            :close-on-click-modal="false"
            :before-close="handleClose">
        <el-steps :active="active" finish-status="success" simple style="margin-bottom: 40px">
            <el-step title="商品信息" />
            <el-step title="图文详情" />
        </el-steps>
        <SingProduct v-if="active === 0" ref="SingProduct" :store-goods-id="storeGoodsId"  @changeComponent1Data="component1DataChange" />
    </el-dialog>
</template>

<script>
    import SingProduct from "./components/SingProduct";
import CaseList from "./components/case/CaseList";
    export default {
        name: "AddUpdataGoods",
        components:{
            SingProduct,CaseList
        },
        props:{
            id:{
                type:Number,
                default:0
            },

        },
        data(){
            return{
                dialogVisible:false,
                active: 0,
                storeGoodsId:0,
                storeGoodsStatus:0
            }
        },

        watch:{
            storeGoodsId(n,o){
                console.log('新增',n)
                console.log('旧知',o)
            },
            storeGoodsStatus(n,o){
                console.log('新增1',n)
                console.log('旧知2',o)
                this.storeGoodsStatus=n
            }
        },
        methods:{
            /**
                * 父组件处理子组件发送的数据更改
                * @param params
                */
            component1DataChange(params) {

                this.active += params;
            },
            resetForm(formName) {
                //this.$refs['goods'].resetFields();
                this.dialogVisible = false
                // this.$nextTick(()=>{
                //     this.$refs.goods.handleClose();
                //     this.$refs.caseList.handleClose();
                // })
            },
           
            init(id) {
                console.log('this.storeGoodsId:',id)
                this.storeGoodsId=id;
                this.dialogVisible = true;
                this.active=0;
                console.log('this.storeGoodsId:',this.storeGoodsId)
            }
        }
    }
</script>

<style scoped>

</style>
